import { ePageSettingActionTypeDefine } from "../../action-types/common/IPageSettingActions";
import { generateActions } from "../generateActions";

export const pageSettingActions = {
    ...generateActions(ePageSettingActionTypeDefine, "PAGE_SETTING")
}